import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('SocialIconFB')).forEach(el => {
    el.setAttribute('class', 'icon-wrapper');
    render(
      <svg
        className="connect__icon icon icon__facebook-circle"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130 130"
      >
        <circle className="circle" cx="65" cy="65" r="63"/>
        <circle className="circle circle__inner" cx="65" cy="65" r="60"/>
        <path
          className="foreground"
          d="M84,49.05H69.69V39.76c0-3.57,2.14-4.28,4-4.28h10V20H69.93C54.45,20,51.12,31.67,51.12,38.81V49.05H42V65h9v45H69.88V65H82.5Z"
          transform="translate(0 0)"
        />
      </svg>,
      el
    );
  });
};
